/**
 * @generated SignedSource<<fb840ce2af426dc9bbc17e529cefe3ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplayQuestions$data = {
  readonly dbQuestions: ReadonlyArray<{
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ShowQuestion">;
  }>;
  readonly " $fragmentType": "DisplayQuestions";
};
export type DisplayQuestions$key = {
  readonly " $data"?: DisplayQuestions$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplayQuestions">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplayQuestions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Question",
      "kind": "LinkedField",
      "name": "dbQuestions",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShowQuestion"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ExamVersion",
  "abstractKey": null
};

(node as any).hash = "0762de9445d3a81a3e1d1bd4dd710516";

export default node;
